"use client";
import {
  useCompositeRenderer
} from "../__chunks/UPJMZO6L.js";
import {
  getCollectionRendererItem,
  getCollectionRendererItemId
} from "../__chunks/UZMGSJE4.js";
import {
  useSelectContext
} from "../__chunks/TKSBJDO3.js";
import "../__chunks/3D6OCOHF.js";
import "../__chunks/MADQZZRL.js";
import "../__chunks/TE637IA7.js";
import "../__chunks/XXVAHUAO.js";
import "../__chunks/J55AVALY.js";
import {
  createElement,
  forwardRef
} from "../__chunks/5M6RSQEC.js";
import {
  useStoreState
} from "../__chunks/EKQEJRUF.js";
import "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/select/select-renderer.tsx
import { useMemo } from "react";
import { toArray } from "@ariakit/core/utils/array";
var TagName = "div";
function getItemObject(item) {
  if (!item || typeof item !== "object") {
    return { value: `${item}` };
  }
  return item;
}
function findIndicesByValue(items, value) {
  var _a;
  const values = toArray(value);
  const indices = [];
  for (const [index, item] of items.entries()) {
    if (indices.length === values.length)
      break;
    const object = getItemObject(item);
    if (object.value != null && values.includes(object.value)) {
      indices.push(index);
    } else if ((_a = object.items) == null ? void 0 : _a.length) {
      const childIndices = findIndicesByValue(object.items, value);
      if (childIndices.length) {
        indices.push(index);
      }
    }
  }
  return indices;
}
function useSelectRenderer(_a) {
  var _b = _a, {
    store,
    orientation: orientationProp,
    persistentIndices: persistentIndicesProp,
    items: itemsProp,
    value: valueProp
  } = _b, props = __objRest(_b, [
    "store",
    "orientation",
    "persistentIndices",
    "items",
    "value"
  ]);
  const context = useSelectContext();
  store = store || context;
  const items = useStoreState(store, (state) => {
    if (!state)
      return itemsProp;
    if (!state.mounted)
      return 0;
    return itemsProp != null ? itemsProp : state.items;
  });
  const value = useStoreState(store, (state) => valueProp != null ? valueProp : state == null ? void 0 : state.value);
  const valueIndices = useMemo(() => {
    if (!items)
      return [];
    if (value == null)
      return [];
    if (typeof items === "number")
      return [];
    if (!items.length)
      return [];
    return findIndicesByValue(items, value);
  }, [items, value]);
  const persistentIndices = useMemo(() => {
    if (persistentIndicesProp) {
      return [...persistentIndicesProp, ...valueIndices];
    }
    return valueIndices;
  }, [valueIndices, persistentIndicesProp]);
  return useCompositeRenderer(__spreadValues({
    store,
    items,
    persistentIndices
  }, props));
}
var SelectRenderer = forwardRef(function SelectRenderer2(props) {
  const htmlProps = useSelectRenderer(props);
  return createElement(TagName, htmlProps);
});
export {
  SelectRenderer,
  getCollectionRendererItem as getSelectRendererItem,
  getCollectionRendererItemId as getSelectRendererItemId
};
